// extracted by mini-css-extract-plugin
export default {"choose":"Choose_choose__JQXyF","grid":"Choose_grid__qu8YT","lottie":"Choose_lottie__ZqrpD","box":"Choose_box__oVpCp","icoWrapp":"Choose_icoWrapp__-UsSu"};